import React from 'react';
import styled from 'styled-components';
import { withFastDeliveryExperiment } from '@catalogo/service-americanas-search/src/experiments/fast-delivery-experiment';
import FreightTag from '../atoms/freight-tag';
import CachBackTag from '../atoms/cashback-tag';

export const ListStamps = ({ className, fastDeliveryExperiment, ...cardProps }) => (
  <Container className={className}>
    <CachBackTag {...cardProps} />
    <FreightTag {...cardProps} />
  </Container>
);

const Container = styled.div`
  display: grid;
  gap: 2px;
  &:empty {
    display: none;
  }
`;

export default withFastDeliveryExperiment(ListStamps);
